import { InteractiveList } from '@nimbus-ds/patterns';
import { ImageItemStratusSkeleton, Repeater } from 'commons/components';

const PRODUCT_IMAGE_WIDTH = '56px';

const getProductItemSkeleton = (i: number) => (
  <InteractiveList.CheckboxItemSkeleton
    key={i}
    title={i.toString()}
    showTitle={false}
  >
    <ImageItemStratusSkeleton imageWidth={PRODUCT_IMAGE_WIDTH} />
  </InteractiveList.CheckboxItemSkeleton>
);

function Skeleton(): JSX.Element {
  return (
    <InteractiveList>
      <Repeater item={getProductItemSkeleton} />
    </InteractiveList>
  );
}

export default Skeleton;
